<template lang="pug">
  .exp-awards
    title-bar(style="margin-bottom: 20px") {{ $t('③ 经验&奖项') }}

    el-row.row(:gutter="20")
      el-col(style="width: 150px;font-size: 12px") {{ $t('行业经验') }}
      el-col.tip(:span="15")
        span {{ $t('请提供相关行业内服务经验最多的3个客户') }}
        span(style="font-weight: bold") {{ $t('（至少1个行业的3个客户）') }}

    el-row.row.experience__title(:gutter="24" style="margin-left: 140px")
      el-col(:span="4") Industry
      el-col(:span="4") Client 1
      el-col(:span="4") Client 2
      el-col(:span="4") Client 3

    el-row.row(
      v-for="item, index in experience"
      :key="index"
      :gutter="24"
      style="margin-left: 140px"
    )
      el-col(
        :class="{ expawards__required: index === 0 }"
        :span="4"
        style="width:200px"
      )
        el-select(v-model="item.id")
          el-option(
            v-for="item, index in industries"
            :key="index"
            :label="$t(item.industry_name)"
            :value="item.industry_id"
          )
      el-col(:span="4" style="width:200px")
        el-input(v-model="item.client1")
      el-col(:span="4" style="width:200px")
        el-input(v-model="item.client2")
      el-col(:span="4" style="width:200px")
        el-input(v-model="item.client3")

    el-row.row(:gutter="20" style="margin: 22px -10px 0")
      el-col(style="width: 150px; font-size: 12px") {{ $t('获奖情况') }}
      el-col(:span="15")
        .award(v-for="(item, index) in award" :key="index" )
          el-input(
            v-model="item.award_name"
            style="margin-right: 10px"
            :maxlength="100"
            :placeholder="$t('填写奖项名称')"
          )
          el-upload(
            action="-"
            :http-request="upload(item)"
            :show-file-list="false"
            accept="image/gif,image/jpeg,image/jpg,image/png"
            :before-upload="onBeforeUpload"
          )
            el-button(type="primary") {{ $t('点击上传') }}
          span(v-if="!item.downloadPath") ({{ $t('仅JPG/JPEG/PNG/GIF') }})
          a(
            :href="item.downloadPath"
            style="margin-left: 10px;max-width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
            target="_blank"
          ) {{ item.fileName }}
          el-button(
            icon="el-icon-delete"
            circle
            style="margin-left: 10px"
            @click="deleAward(index)"
          )
    el-button(type="text" style="margin-left: 150px" @click="addAward") + {{ $t('新增奖项') }}
</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import { groupBy } from 'lodash'

export default {
  components: {
    TitleBar
  },
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      experience: [
        {
          id: null,
          client1: '',
          client2: '',
          client3: ''
        },
        {
          id: null,
          client1: '',
          client2: '',
          client3: ''
        },
        {
          id: null,
          client1: '',
          client2: '',
          client3: ''
        }
      ],
      award: [
        {
          fileName: '',
          path: '',
          downloadPath: '',
          award_name: ''
        }
      ],
      industries: []
    }
  },
  watch: {
    data () {
      const exp = groupBy(this.data.experience, 'industry_id')
      Object.keys(exp).forEach((item, index) => {
        this.experience[index].id = Number(item)
        exp[item] && exp[item].map(item => {
          this.experience[index][`client${item.seq}`] = item.client_name
        })
      })

      if (this.data.award.length !== 0) {
        this.award = this.data.award.map(item => ({
          fileName: item.file_name,
          path: item.award_path,
          downloadPath: item.download_url,
          award_name: item.award_name
        }))
      }
    }
  },
  mounted () {
    this.fetchIndustries()
  },
  methods: {
    async fetchIndustries () {
      this.industries = await axios.get('/vendor/vendor/getIndustry')
    },
    deleAward (index) {
      this.award.splice(index, 1)
    },
    addAward () {
      this.award.push({
        fileName: '',
        path: null,
        downloadPath: null,
        award_name: ''
      })
    },
    upload (award) {
      return async (inst) => {
        const formData = new window.FormData()
        formData.append('file', inst.file)
        formData.append('file_type', 6)
        const res = await axios.post('/management/subfinal/saveFile', formData)
        award.path = res.file_path
        award.fileName = res.file_name
        award.downloadPath = res.file_download_path
      }
    },
    onBeforeUpload (file) {
      const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/png'
      if (!isIMAGE) {
        this.$message.error()
      }
      return isIMAGE
    },
    submit () {
      const { award, experience } = this

      if (!experience.find(item =>
        item.client1 !== '' &&
        item.client2 !== '' &&
        item.client3 !== '' &&
        item.id != null)) {
        throw new Error(this.$t('请填写至少一个行业（3个客户）'))
      }
      return { award, experience }
    }
  }
}
</script>

<style lang="stylus" scoped>
.tip
  color #666666

.row
  margin 10px 0

.award
  display flex
  margin-bottom 20px
  > span
    font-size 12px
    color #808080
    margin-left 5px

.expawards__required
  position relative

.expawards__required::before
  position absolute
  top 0
  left 0
  content '*'
  color red
  margin-right 5px
.experience__title
  .el-col
    text-align center
    width 200px
</style>
